import { gql } from '@apollo/client';

export const SEARCH_CITY_BY_NAME = gql`
	query searchCitiesByName($cityName: String!) {
		searchCitiesByName(cityName: $cityName) {
			id
			name
			timezone
		}
	}
`;

export const SEACH_CITIES_WITH_STATIONS_ONLY = gql`
	query searchCitiesWithStations($cityName: String!) {
		searchCitiesWithStationsByName(cityName: $cityName) {
			id
			name
			timezone
		}
	}
`;
